import { FC } from 'react';
import { connect } from 'react-bootstrap-formutil';
import NonSSN from './NonSSN';
import SSN from './SSN';
import { PersonalInfoProps } from './type';

const PersonalInfo: FC<PersonalInfoProps> = ({ isSSN, ...restProps }) => {
    return isSSN ? <SSN {...restProps} /> : <NonSSN {...restProps} />;
};

export default connect(PersonalInfo);
export * from './helper';
export * from './type';
